import { EntityType } from "../core";

export interface Report {
    id: string;
    name: string;
    applicationType: EntityType;
    submittedAt: number;

    statusMessage?: string;
    
    history: HistoryEntry[];
}

export interface HistoryEntry {
    label: string;
    description: string;
    date: number;

    type: "INFO"|"ACTION_REQUIRED"|"FUTURE"
    statusId: string;
}